module.exports = __webpack_public_path__ + "media/images/pepper-b3abad787d1ce56a0b6dd441eecb8d47.png";